import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import SearchBox from "../../components/general/searchBox";
import DeleteOrganizationModal from "../../components/organization/deleteOrganizationModal";
import { useWindowSize } from "../../../hook/useWindowSize";
import { useMySearchParams } from "../../../hook/useMySearchParams";
import Pagination from "../../components/general/table/pagination";
import {useFindAccessInAccessList} from "../../../constants/constant/accessProcess";
import {
    useGetHistoryPrescriptionOrderList
} from "../../../hook/request/ihioPrescriptionFilling";
import PrescriptionHistoryTable from "../../components/ihioPrescriptionHistory/dataList/prescriptionHistoryTable";
import OrderedPrescriptionInfoModal
    from "../../components/ihioPrescriptionBill/orderedPrescriptionInfoModal/orderedPrescriptionInfoModal";

const dataListTitles = [
    "نام و نام خانوادگی",
    "شماره ملی",
    "تاریخ مراجعه",
    "وضعیت",
    "شناسه رهگیری",
    "عملیات",
]

type TFilterValues = {
    pageNumber?: string;
    perPage?: string;
    search?: string;
}

const PrescriptionHistoryList = () => {

    const [width] = useWindowSize();
    const {findAccessInAccessList} = useFindAccessInAccessList();
    const [searchParams] = useSearchParams();
    const { getQueryParams, updateSearchParams } = useMySearchParams();
    const [prescriptionFillingsData, setPrescriptionFillingsData] = useState([]);
    const [filterValues, setFilterValues] = useState<TFilterValues>({
        pageNumber: "0",
        perPage: "10",
        search: "",
    });

    // services
    const getHistoryPrescriptionOrderListRequest = useGetHistoryPrescriptionOrderList(getQueryParams(filterValues));

    useEffect(() => {
        let _filterValues = {};
        _filterValues = {
            ...filterValues,
            pageNumber: searchParams.get("pageNumber") || "0",
            perPage: searchParams.get("perPage") || "10",
            search: searchParams.get("search") || ""
        }
        setFilterValues(_filterValues)
    }, [searchParams]);

    useEffect(() => {
        getHistoryPrescriptionOrderListRequest?.data?.data?.result &&
        setPrescriptionFillingsData(getHistoryPrescriptionOrderListRequest?.data?.data.result)
    }, [getHistoryPrescriptionOrderListRequest.data])

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        updateSearchParams({
            pageNumber: "0",
            perPage: filterValues?.perPage,
            [name]: value,
        })
    }

    const doChangePage = (param: any) => {
        updateSearchParams({
            pageNumber: param?.index,
            perPage: filterValues?.perPage,
        })
    }

    return (
        <>
            <div className="card-box">
                <section className="filter-box d-flex flex-column flex-md-row mb-4">
                    <div className="form-group ms-md-auto">
                        <SearchBox
                            name="search"
                            value={filterValues?.search}
                            onChange={handleFilterChange}
                            placeholder="جستجوی تجویز"
                        />
                    </div>
                </section>

                <section className="table-cont table-responsive">
                    <PrescriptionHistoryTable
                        dataList={prescriptionFillingsData}
                        dataListTitles={dataListTitles}
                        isRequesting={getHistoryPrescriptionOrderListRequest.isPending}
                    />
                    <Pagination
                        paginationData={{...filterValues, ...prescriptionFillingsData}}
                        doChangePage={doChangePage}
                    />
                </section>
            </div>
            <OrderedPrescriptionInfoModal/>
        </>
    );
};

export default PrescriptionHistoryList;